export enum HotelBookingPartnerSearchQueryParams {
  placeId = 'placeId',
  placeIdType = 'placeIdType',
  name = 'name',
  checkIn = 'checkIn',
  checkOut = 'checkOut',
  source = 'source'
}
